/**
 * Created by cate on 24-08-17.
 */
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[steel-profile-form]',
})
export class SteelProfileFormDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/steel-profile-form.directive.ts